import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from '../locales/en.json'
import mn from '../locales/mn.json'

Vue.use(VueI18n)

const savedLang = localStorage.getItem('lang') || 'mn'

export default new VueI18n({
  locale: savedLang,
  fallbackLocale: 'en',
  messages: { en, mn },
})
